export default __webpack_public_path__ + "static/media/daybook.5c34e6b4.svg";